import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Messages from './messages-dropdown/MessagesDropdown';
import Notifications from './notifications-dropdown/NotificationsDropdown';
import Languages from './languages-dropdown/LanguagesDropdown';
import User from './user-dropdown/UserDropdown';

const Header = ({toggleMenuSidebar}) => {
    const [t] = useTranslation();

    const userTmp =  localStorage.getItem("profile");
    let view_navigate = true;
    let isSalesman = false;
    if(userTmp  )
    {
        const nv = JSON.parse(userTmp);
        if(nv && nv.role && nv.role.length > 0 && nv.role.includes("SALEMAN") ) {
            view_navigate = false;
            isSalesman = true;
        }
    }

    return (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            {/* Left navbar links */}
            <ul className="navbar-nav">
                {view_navigate && (<li className="nav-item">
                    <button
                        onClick={() => toggleMenuSidebar()}
                        type="button"
                        className="nav-link"
                    >
                        <i className="fas fa-bars" />
                    </button>
                </li>)
                }
                <li className="nav-item">
                    <Link to="/" className="nav-link">
                        Trang chủ
                    </Link>
                </li>

                {/*   <li className="nav-item d-none d-sm-inline-block">
                    <Link to="/" className="nav-link text-nowrap">
                        menu 2
                    </Link>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <Link to="/" className="nav-link text-nowrap">
                        menu 3
                    </Link>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <Link to="/" className="nav-link text-nowrap">
                        menu 4
                    </Link>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <Link to="/" className="nav-link text-nowrap">
                        menu 5
                    </Link>
                </li>*/}
            </ul>
            <ul className="navbar-nav ml-auto">

                {/* <li className="nav-item">
                    <button className="nav-link" type="button">
                        <i className="fas fa-search" />
                    </button>
                    <div className="navbar-search-block">
                        <form className="form-inline">
                            <div className="input-group input-group-sm">
                                <input
                                    className="form-control form-control-navbar"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                />
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-navbar"
                                        type="submit"
                                    >
                                        <i className="fas fa-search" />
                                    </button>
                                    <button
                                        className="btn btn-navbar"
                                        type="button"
                                        data-widget="navbar-search"
                                    >
                                        <i className="fas fa-times" />
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </li> */}
                {/*<Messages />*/}
                <Notifications />
               {/*
                <Languages />*/}
                <User />
            </ul>
        </nav>
    );
};

export default Header;
